import { put, call, takeLatest, all } from 'redux-saga/effects';
import { createAction, SimpleActionType } from '../utils/storeUtils';
import { apiFetch, FetchResponse } from '../novaApi/apiUtils';
import { addErrorNotification, addSuccessNotification } from './notifications';
import { invalidateNovaQueries } from 'novaApi/useNovaApi';

const DELETE_TERM = 'DELETE_TERM';

export const deleteTerm = createAction(DELETE_TERM);

export const sagas = {
  *deleteTermSaga(action: SimpleActionType) {
    const results: FetchResponse<any> = yield call(
      apiFetch,
      `/term/${action.payload.uuid}`,
      {
        method: 'DELETE',
      },
    );
    if (results.success) {
      yield put(addSuccessNotification({ message: 'Term has been deleted' }));
      invalidateNovaQueries(`/term`);
    } else {
      yield put(
        addErrorNotification({
          message: 'There was an error deleting the term',
        }),
      );
    }
  },
};

// Root Saga
export function* rootSaga() {
  yield all([takeLatest(DELETE_TERM, sagas.deleteTermSaga)]);
}
